import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { portfolioFilterSummary } from "web_myplann/Portfolio/Helpers/portfolioFilterSummary";
import { useEffectivePortfolioFilter } from "web_myplann/Portfolio/Hooks/useEffectivePortfolioFilter";
import { ListFilterChip } from "web_myplann/Shared/Components/Redesign/ListFilterChip";

export const PortfolioFilterChip: FC = () => {
	const { t } = useResource();
	const navigate = useNavigate();
	const { filter } = useEffectivePortfolioFilter();

	return (
		<ListFilterChip
			summary={portfolioFilterSummary(filter, t)}
			onClick={() => navigate(Routing.Portfolio.PortfolioFilter.path())}
		/>
	);
};
